import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["object"],
    relationships: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "relationships", {
            groupID,
            eLynxObject
        }
    ]
};